// Generated by scripts/prop-sizes.mjs from public/assets/kenney/manifest.json: each scenery model's
// width, height and depth (model units, glTF Y up) and the height of its lowest point.

export const PROP_SIZES: Record<string, readonly [number, number, number, number]> = {
  cactus_short: [0.34, 0.53, 0.3, -0.05],
  cactus_tall: [0.4, 0.75, 0.34, -0.05],
  campfire_bricks: [0.47, 0.07, 0.47, -0.05],
  campfire_logs: [0.29, 0.06, 0.29, -0.05],
  campfire_planks: [0.35, 0.04, 0.35, -0.05],
  campfire_stones: [0.54, 0.08, 0.52, -0.05],
  crop_pumpkin: [0.44, 0.33, 0.45, -0.05],
  flower_purpleA: [0.16, 0.24, 0.18, -0.05],
  flower_purpleB: [0.21, 0.21, 0.24, -0.05],
  flower_purpleC: [0.18, 0.18, 0.18, -0.05],
  flower_redA: [0.16, 0.29, 0.18, -0.05],
  flower_redB: [0.21, 0.26, 0.24, -0.05],
  flower_redC: [0.18, 0.23, 0.18, -0.05],
  flower_yellowA: [0.16, 0.19, 0.18, -0.05],
  flower_yellowB: [0.21, 0.16, 0.24, -0.05],
  flower_yellowC: [0.18, 0.13, 0.18, -0.05],
  grass: [0.38, 0.25, 0.39, -0.05],
  grass_large: [0.41, 0.25, 0.41, -0.05],
  grass_leafs: [0.23, 0.14, 0.26, -0.05],
  grass_leafsLarge: [0.48, 0.14, 0.49, -0.05],
  lily_large: [0.27, 0.1, 0.31, -0.05],
  lily_small: [0.19, 0.04, 0.22, -0.05],
  mushroom_red: [0.17, 0.2, 0.2, -0.05],
  mushroom_redGroup: [0.27, 0.25, 0.25, -0.05],
  mushroom_redTall: [0.12, 0.25, 0.14, -0.05],
  mushroom_tan: [0.19, 0.15, 0.22, -0.05],
  mushroom_tanGroup: [0.27, 0.25, 0.25, -0.05],
  mushroom_tanTall: [0.12, 0.25, 0.14, -0.05],
  plant_bush: [0.4, 0.24, 0.4, -0.05],
  plant_bushDetailed: [0.6, 0.36, 0.6, -0.05],
  plant_bushLarge: [0.37, 0.24, 0.34, -0.05],
  plant_bushLargeTriangle: [0.41, 0.17, 0.47, -0.05],
  plant_bushSmall: [0.38, 0.21, 0.34, -0.05],
  plant_bushTriangle: [0.36, 0.3, 0.41, -0.05],
  plant_flatShort: [0.28, 0.24, 0.28, -0.05],
  plant_flatTall: [0.27, 0.28, 0.27, -0.05],
  pot_large: [0.56, 0.2, 0.49, -0.05],
  pot_small: [0.32, 0.27, 0.28, -0.05],
  rock_largeA: [0.78, 0.26, 1.02, -0.05],
  rock_largeB: [0.77, 0.43, 1.02, -0.05],
  rock_largeC: [1.06, 0.32, 1.02, -0.05],
  rock_largeD: [1.07, 0.57, 1.03, -0.05],
  rock_largeE: [1.1, 0.29, 0.92, -0.05],
  rock_largeF: [1.1, 0.48, 0.9, -0.05],
  rock_smallA: [0.36, 0.19, 0.36, -0.05],
  rock_smallB: [0.36, 0.18, 0.36, -0.05],
  rock_smallC: [0.36, 0.12, 0.36, -0.05],
  rock_smallD: [0.43, 0.23, 0.37, -0.05],
  rock_smallE: [0.36, 0.26, 0.31, -0.05],
  rock_smallF: [0.35, 0.25, 0.31, -0.05],
  rock_smallFlatA: [0.5, 0.06, 0.43, -0.05],
  rock_smallFlatB: [0.43, 0.06, 0.4, -0.05],
  rock_smallFlatC: [0.47, 0.06, 0.36, -0.05],
  rock_smallG: [0.59, 0.25, 0.69, -0.05],
  rock_smallH: [0.46, 0.41, 0.46, -0.05],
  rock_smallI: [0.36, 0.28, 0.41, -0.05],
  rock_smallTopA: [0.49, 0.22, 0.49, -0.05],
  rock_smallTopB: [0.62, 0.28, 0.65, -0.05],
  rock_tallA: [0.98, 1, 0.68, -0.05],
  rock_tallB: [0.76, 0.88, 0.77, -0.05],
  rock_tallC: [0.46, 0.78, 0.44, -0.05],
  rock_tallD: [0.44, 0.77, 0.46, -0.05],
  rock_tallE: [0.46, 0.44, 0.53, -0.05],
  rock_tallF: [0.44, 0.57, 0.51, -0.05],
  rock_tallG: [0.42, 0.78, 0.49, -0.05],
  rock_tallH: [0.57, 0.71, 0.66, -0.05],
  rock_tallI: [0.46, 0.81, 0.46, -0.05],
  rock_tallJ: [0.49, 0.62, 0.54, -0.05],
  statue_block: [0.4, 0.4, 0.4, -0.05],
  statue_column: [0.3, 1, 0.3, -0.05],
  statue_columnDamaged: [0.3, 0.7, 0.3, -0.05],
  statue_head: [0.73, 1, 0.55, -0.05],
  statue_obelisk: [0.31, 0.88, 0.31, -0.05],
  statue_ring: [0.6, 0.8, 0.4, -0.05],
  stone_tallA: [0.98, 1, 0.68, -0.05],
  stone_tallB: [0.76, 0.88, 0.77, -0.05],
  stone_tallC: [0.46, 0.78, 0.44, -0.05],
  stone_tallD: [0.44, 0.77, 0.46, -0.05],
  stone_tallE: [0.46, 0.44, 0.53, -0.05],
  stone_tallF: [0.44, 0.57, 0.51, -0.05],
  stone_tallG: [0.42, 0.78, 0.49, -0.05],
  stone_tallH: [0.57, 0.71, 0.66, -0.05],
  stone_tallI: [0.46, 0.81, 0.46, -0.05],
  stone_tallJ: [0.49, 0.62, 0.54, -0.05],
  tree_blocks: [0.6, 1.19, 0.6, -0.05],
  tree_blocks_dark: [0.6, 1.19, 0.6, -0.05],
  tree_blocks_fall: [0.6, 1.19, 0.6, -0.05],
  tree_cone: [0.53, 1.43, 0.53, -0.05],
  tree_cone_dark: [0.53, 1.43, 0.53, -0.05],
  tree_cone_fall: [0.53, 1.43, 0.53, -0.05],
  tree_default: [0.76, 1.71, 0.65, -0.05],
  tree_default_dark: [0.76, 1.71, 0.65, -0.05],
  tree_default_fall: [0.76, 1.71, 0.65, -0.05],
  tree_detailed: [0.85, 1.33, 0.76, -0.05],
  tree_detailed_dark: [0.85, 1.33, 0.76, -0.05],
  tree_detailed_fall: [0.85, 1.33, 0.76, -0.05],
  tree_fat: [0.76, 1.15, 0.65, -0.05],
  tree_fat_darkh: [0.76, 1.15, 0.65, -0.05],
  tree_fat_fall: [0.76, 1.15, 0.65, -0.05],
  tree_oak: [0.64, 1.23, 0.74, -0.05],
  tree_oak_dark: [0.64, 1.23, 0.74, -0.05],
  tree_oak_fall: [0.64, 1.23, 0.74, -0.05],
  tree_palm: [0.94, 1.51, 1.01, -0.05],
  tree_palmBend: [0.94, 1.38, 1.01, -0.05],
  tree_palmDetailedShort: [1.46, 1.12, 1.46, -0.05],
  tree_palmDetailedTall: [1.46, 1.42, 1.46, -0.05],
  tree_palmShort: [1.03, 1.06, 1.03, -0.05],
  tree_palmTall: [1.03, 1.36, 1.03, -0.05],
  tree_pineDefaultA: [0.53, 1.55, 0.53, -0.05],
  tree_pineDefaultB: [0.53, 1.55, 0.53, -0.05],
  tree_pineGroundA: [0.48, 0.91, 0.55, -0.05],
  tree_pineGroundB: [0.48, 1.04, 0.55, -0.05],
  tree_pineRoundA: [0.62, 1.37, 0.71, -0.05],
  tree_pineRoundB: [0.53, 1.2, 0.61, -0.05],
  tree_pineRoundC: [0.48, 1.25, 0.55, -0.05],
  tree_pineRoundD: [0.48, 1.08, 0.55, -0.05],
  tree_pineRoundE: [0.53, 1.25, 0.53, -0.05],
  tree_pineRoundF: [0.53, 1.25, 0.53, -0.05],
  tree_pineSmallA: [0.5, 0.97, 0.5, -0.05],
  tree_pineSmallB: [0.39, 1.01, 0.39, -0.05],
  tree_pineSmallC: [0.39, 1.12, 0.39, -0.05],
  tree_pineSmallD: [0.36, 0.96, 0.36, -0.05],
  tree_pineTallA: [0.39, 1.53, 0.39, -0.05],
  tree_pineTallA_detailed: [0.39, 1.53, 0.39, -0.05],
  tree_pineTallB: [0.39, 1.93, 0.39, -0.05],
  tree_pineTallB_detailed: [0.39, 1.93, 0.39, -0.05],
  tree_pineTallC: [0.48, 1.67, 0.55, -0.05],
  tree_pineTallC_detailed: [0.48, 1.67, 0.55, -0.05],
  tree_pineTallD: [0.48, 2.08, 0.55, -0.05],
  tree_pineTallD_detailed: [0.48, 2.08, 0.55, -0.05],
  tree_plateau: [0.61, 1.25, 0.65, -0.05],
  tree_plateau_dark: [0.61, 1.25, 0.65, -0.05],
  tree_plateau_fall: [0.61, 1.25, 0.65, -0.05],
  tree_simple: [0.35, 1.52, 0.41, -0.05],
  tree_simple_dark: [0.35, 1.52, 0.41, -0.05],
  tree_simple_fall: [0.35, 1.52, 0.41, -0.05],
  tree_small: [0.35, 1.11, 0.41, -0.05],
  tree_small_dark: [0.35, 1.11, 0.41, -0.05],
  tree_small_fall: [0.35, 1.11, 0.41, -0.05],
  tree_tall: [0.4, 1.69, 0.46, -0.05],
  tree_tall_dark: [0.4, 1.69, 0.46, -0.05],
  tree_tall_fall: [0.4, 1.69, 0.46, -0.05],
  tree_thin: [0.68, 1.49, 0.62, -0.05],
  tree_thin_dark: [0.68, 1.49, 0.62, -0.05],
  tree_thin_fall: [0.68, 1.49, 0.62, -0.05],
  'space-alien': [0.48, 0.84, 0.33, 0],
  'space-astronautA': [0.48, 0.79, 0.33, 0],
  'space-astronautB': [0.48, 0.79, 0.33, 0],
  'space-barrel': [0.2, 0.25, 0.17, 0],
  'space-barrels': [0.55, 0.35, 0.5, 0],
  'space-bones': [0.86, 0.44, 0.58, 0],
  'space-craft_cargoA': [1.6, 0.8, 2.45, 0],
  'space-craft_cargoB': [1.5, 0.9, 2.5, 0],
  'space-craft_miner': [1.8, 0.7, 2.6, 0],
  'space-craft_racer': [1.2, 0.75, 2.03, 0],
  'space-craft_speederA': [2, 0.8, 2.1, 0],
  'space-craft_speederB': [2, 0.6, 2.03, 0],
  'space-craft_speederC': [2.8, 0.6, 1.93, 0],
  'space-craft_speederD': [2.8, 0.9, 2.23, 0],
  'space-crater': [0.71, 0.12, 0.83, 0],
  'space-craterLarge': [0.89, 0.12, 0.89, 0],
  'space-hangar_roundA': [3.27, 1.5, 2.83, 0],
  'space-hangar_roundB': [3.27, 1.8, 2.83, 0],
  'space-hangar_roundGlass': [3.27, 1.4, 2.83, 0],
  'space-machine_barrel': [0.65, 0.6, 0.52, 0],
  'space-machine_barrelLarge': [0.75, 0.6, 0.75, 0],
  'space-machine_generator': [0.7, 0.4, 0.53, 0],
  'space-machine_generatorLarge': [1, 0.68, 1.3, 0],
  'space-machine_wireless': [0.75, 0.6, 0.5, 0],
  'space-machine_wirelessCable': [0.75, 0.8, 0.6, 0],
  'space-meteor': [0.87, 0.73, 0.75, 0],
  'space-meteor_detailed': [0.87, 0.73, 0.83, 0],
  'space-meteor_half': [0.87, 0.37, 0.75, 0],
  'space-monorail_trainCargo': [0.5, 0.64, 1, 0],
  'space-monorail_trainFront': [0.6, 0.8, 1.05, 0],
  'space-monorail_trainPassenger': [0.5, 0.8, 1, 0],
  'space-pipe_ring': [0.92, 0.8, 1, -0.1],
  'space-pipe_ringHigh': [0.92, 1.3, 1, 0],
  'space-pipe_ringHighEnd': [0.92, 1.3, 0.8, 0],
  'space-pipe_ringSupport': [0.92, 1.3, 0.4, 0],
  'space-rock': [0.8, 0.3, 0.85, 0],
  'space-rocket_baseA': [1.8, 1.6, 1.8, 0],
  'space-rocket_baseB': [1.8, 1.3, 1.8, 0],
  'space-rocket_finsA': [1.2, 0.7, 1.2, 0],
  'space-rocket_finsB': [1.2, 0.7, 1.2, 0],
  'space-rocket_fuelA': [1, 0.5, 1, 0],
  'space-rocket_fuelB': [1, 1, 1, 0],
  'space-rocket_sidesA': [1, 1, 1, 0],
  'space-rocket_sidesB': [1.3, 1, 1.3, 0],
  'space-rocket_topA': [1, 0.8, 1, 0],
  'space-rocket_topB': [1, 1.1, 1, 0],
  'space-rocks_smallA': [0.94, 0.11, 0.87, 0],
  'space-rocks_smallB': [0.73, 0.19, 0.7, 0],
  'space-rock_crystals': [0.85, 0.34, 0.8, 0],
  'space-rock_crystalsLargeA': [0.83, 0.54, 0.92, 0],
  'space-rock_crystalsLargeB': [0.94, 0.55, 0.93, 0],
  'space-rock_largeA': [0.92, 0.5, 0.83, 0],
  'space-rock_largeB': [0.93, 0.5, 0.94, 0],
  'space-rover': [0.3, 0.39, 0.35, 0.01],
  'space-satelliteDish': [0.69, 0.62, 0.57, 0],
  'space-satelliteDish_detailed': [0.7, 0.62, 0.7, 0],
  'space-satelliteDish_large': [0.85, 0.81, 0.74, 0],
  'space-supports_high': [0.83, 1, 0.83, 0],
  'space-turret_double': [0.9, 0.7, 0.6, 0],
  'space-turret_single': [0.6, 0.9, 0.72, 0],
  'winter-bench-short': [0.62, 0.73, 0.63, 0],
  'winter-bench': [1.12, 0.73, 0.63, 0],
  'winter-candy-cane-green': [0.3, 0.45, 0.1, 0],
  'winter-candy-cane-red': [0.3, 0.45, 0.1, 0],
  'winter-gingerbread-man': [0.34, 0.38, 0.08, 0],
  'winter-gingerbread-woman': [0.34, 0.4, 0.12, 0],
  'winter-lantern-hanging': [0.43, 0.67, 0.42, -0.57],
  'winter-lantern': [0.53, 1.74, 0.45, 0],
  'winter-nutcracker': [0.55, 1.08, 0.35, 0],
  'winter-present-a-cube': [0.45, 0.57, 0.45, 0],
  'winter-present-a-rectangle': [0.65, 0.42, 0.45, 0],
  'winter-present-a-round': [0.55, 0.57, 0.55, 0],
  'winter-present-b-cube': [0.45, 0.47, 0.45, 0],
  'winter-present-b-rectangle': [0.65, 0.47, 0.45, 0],
  'winter-present-b-round': [0.55, 0.47, 0.55, 0],
  'winter-reindeer': [0.63, 1.12, 1.07, 0],
  'winter-rocks-large': [3.14, 1.71, 2.69, 0],
  'winter-rocks-medium': [1.98, 0.88, 1.72, 0],
  'winter-rocks-small': [1.54, 0.65, 1.41, 0],
  'winter-sled-long': [0.63, 0.38, 1, 0],
  'winter-sled': [0.63, 0.38, 1, 0],
  'winter-snow-bunker': [1.94, 0.41, 1.35, 0],
  'winter-snow-pile': [0.99, 0.2, 1.11, 0],
  'winter-snowman-hat': [1.08, 1.36, 0.69, 0],
  'winter-snowman': [1.1, 1.06, 0.69, 0],
  'winter-train-locomotive': [0.67, 0.43, 0.27, 0],
  'winter-train-wagon': [0.72, 0.31, 0.21, 0],
  'winter-tree-decorated-snow': [1.25, 2.29, 1.25, 0],
  'winter-tree-decorated': [1.19, 2.29, 1.19, 0],
  'winter-tree-snow-a': [1.19, 1.92, 1.19, 0],
  'winter-tree-snow-b': [1.25, 1.97, 1.25, 0],
  'winter-tree-snow-c': [1.19, 1.92, 1.19, 0],
  'winter-tree': [1.19, 1.92, 1.19, 0],
  'winter-wreath-decorated': [0.67, 0.76, 0.26, 0],
  'winter-wreath': [0.67, 0.76, 0.26, 0],
  'spooky-altar-stone': [1.04, 0.49, 0.65, 0],
  'spooky-altar-wood': [1.05, 0.54, 0.66, 0],
  'spooky-candle-multiple': [0.26, 0.2, 0.27, 0],
  'spooky-candle': [0.14, 0.2, 0.14, 0],
  'spooky-character-ghost': [0.79, 0.66, 0.49, 0.11],
  'spooky-character-skeleton': [0.76, 0.7, 0.32, 0.02],
  'spooky-column-large': [0.39, 1.13, 0.39, 0],
  'spooky-cross-column': [0.45, 1.45, 0.45, 0],
  'spooky-cross-wood': [0.43, 1.04, 0.43, 0],
  'spooky-cross': [0.67, 1.05, 0.25, 0],
  'spooky-crypt-a': [0.62, 0.52, 1.12, 0],
  'spooky-crypt-b': [0.62, 0.52, 1.12, 0],
  'spooky-crypt-large': [1.85, 1, 2.4, 0],
  'spooky-crypt-small': [1.35, 1, 1.4, 0],
  'spooky-crypt': [0.72, 0.73, 1.12, 0],
  'spooky-debris-wood': [0.46, 0.1, 0.5, 0],
  'spooky-debris': [0.54, 0.16, 0.55, 0],
  'spooky-fire-basket': [0.42, 0.17, 0.42, 0],
  'spooky-grave': [0.72, 0.11, 1.24, 0],
  'spooky-gravestone-bevel': [0.45, 0.53, 0.25, 0],
  'spooky-gravestone-broken': [0.51, 0.34, 0.39, 0],
  'spooky-gravestone-cross-large': [0.45, 0.94, 0.33, 0],
  'spooky-gravestone-cross': [0.45, 0.91, 0.33, 0],
  'spooky-gravestone-debris': [0.5, 0.27, 0.64, -0.05],
  'spooky-gravestone-decorative': [0.51, 0.59, 0.25, 0],
  'spooky-gravestone-roof': [0.49, 0.61, 0.25, 0],
  'spooky-gravestone-round': [0.45, 0.57, 0.25, 0],
  'spooky-gravestone-wide': [0.85, 0.57, 0.3, 0],
  'spooky-hay-bale-bundled': [0.61, 0.38, 0.43, 0],
  'spooky-hay-bale': [0.61, 0.35, 0.4, 0.01],
  'spooky-lantern-candle': [0.24, 0.39, 0.24, 0],
  'spooky-lantern-glass': [0.24, 0.39, 0.24, 0],
  'spooky-lightpost-all': [0.73, 1.27, 0.73, 0],
  'spooky-lightpost-double': [0.21, 1.27, 0.73, 0],
  'spooky-lightpost-single': [0.21, 1.27, 0.46, 0],
  'spooky-pillar-large': [0.22, 1.13, 0.22, 0],
  'spooky-pillar-obelisk': [0.35, 1.01, 0.35, 0],
  'spooky-pillar-small': [0.18, 0.76, 0.18, 0],
  'spooky-pillar-square': [0.35, 1.15, 0.35, 0],
  'spooky-pine-crooked': [1.18, 2.11, 1.33, -0.1],
  'spooky-pine-fall-crooked': [1.18, 2.11, 1.33, -0.1],
  'spooky-pine-fall': [1.18, 2.3, 1.33, -0.1],
  'spooky-pine': [1.18, 2.3, 1.33, -0.1],
  'spooky-pumpkin-carved': [0.38, 0.32, 0.38, 0],
  'spooky-pumpkin-tall-carved': [0.33, 0.36, 0.33, 0],
  'spooky-pumpkin-tall': [0.33, 0.36, 0.33, 0],
  'spooky-pumpkin': [0.38, 0.32, 0.38, 0],
  'spooky-rocks-tall': [1.03, 0.59, 1.02, 0],
  'spooky-rocks': [1.08, 0.38, 0.96, 0],
  'spooky-trunk-long': [0.54, 1, 0.54, 0],
  'spooky-trunk': [0.54, 0.45, 0.55, 0],
  'spooky-urn-round': [0.26, 0.38, 0.26, 0],
  'spooky-urn-square': [0.26, 0.38, 0.26, 0],
  'toy-barrel': [0.52, 0.48, 0.52, 0],
  'toy-bomb': [0.49, 0.54, 0.49, 0],
  'toy-character-oobi': [0.87, 0.91, 0.6, 0],
  'toy-character-oodi': [0.87, 0.91, 0.61, 0],
  'toy-character-ooli': [0.87, 0.91, 0.6, 0],
  'toy-character-oopi': [0.87, 0.91, 0.6, 0],
  'toy-character-oozi': [0.87, 0.91, 0.61, 0],
  'toy-chest': [0.5, 0.45, 0.5, 0],
  'toy-coin-bronze': [0.4, 0.4, 0.17, 0],
  'toy-coin-gold': [0.4, 0.4, 0.17, 0],
  'toy-coin-silver': [0.4, 0.4, 0.17, 0],
  'toy-crate-strong': [0.6, 0.6, 0.6, 0],
  'toy-crate': [0.5, 0.5, 0.5, 0],
  'toy-flag': [0.42, 0.9, 0.11, 0],
  'toy-flowers-tall': [0.55, 0.46, 0.62, 0],
  'toy-flowers': [0.78, 0.14, 0.79, 0],
  'toy-heart': [0.41, 0.38, 0.12, 0],
  'toy-hedge-corner': [1, 0.4, 1, 0],
  'toy-hedge': [1, 0.4, 0.3, 0],
  'toy-jewel': [0.33, 0.37, 0.29, 0],
  'toy-key': [0.38, 0.22, 0.07, 0],
  'toy-mushrooms': [0.52, 0.29, 0.51, 0],
  'toy-plant': [0.51, 0.17, 0.44, 0],
  'toy-poles': [1.1, 1, 0.35, 0],
  'toy-rocks': [0.65, 0.4, 0.66, 0],
  'toy-saw': [0.79, 0.79, 0.3, -0.4],
  'toy-sign': [0.48, 0.6, 0.13, 0],
  'toy-spring': [0.75, 0.47, 0.75, 0],
  'toy-star': [0.36, 0.36, 0.24, 0],
  'toy-stones': [0.71, 0.05, 0.79, 0],
  'toy-tree-pine-small': [0.66, 1.4, 0.66, 0],
  'toy-tree-pine-snow-small': [0.66, 1.4, 0.66, 0],
  'toy-tree-pine-snow': [0.95, 2, 0.95, 0],
  'toy-tree-pine': [0.95, 2, 0.95, 0],
  'toy-tree-snow': [1.09, 1.93, 1.11, 0],
  'toy-tree': [1.09, 1.93, 1.11, 0],
  'city-building-a': [0.88, 1.29, 0.94, 0],
  'city-building-b': [0.97, 1.29, 0.94, 0],
  'city-building-c': [0.88, 0.89, 1.09, 0],
  'city-building-d': [0.84, 1.29, 0.9, 0],
  'city-building-e': [1.64, 0.89, 1.01, 0],
  'city-building-f': [0.84, 1.69, 1.03, 0],
  'city-building-g': [0.97, 1.69, 0.92, 0],
  'city-building-h': [0.88, 1.29, 1.01, 0],
  'city-building-i': [1.24, 1.68, 1.3, 0],
  'city-building-j': [2.08, 1.69, 1.34, 0],
  'city-building-k': [2.08, 1.47, 0.94, 0],
  'city-building-l': [1.37, 2.27, 1.4, 0],
  'city-building-m': [1.24, 3.15, 1.24, 0],
  'city-building-n': [2.32, 2.48, 1.82, 0],
  'city-building-skyscraper-a': [1.36, 2.88, 1.36, 0],
  'city-building-skyscraper-b': [1.36, 4.48, 1.36, 0],
  'city-building-skyscraper-c': [1.28, 4.08, 1.39, 0],
  'city-building-skyscraper-d': [1.28, 5.47, 1.39, 0],
  'city-building-skyscraper-e': [1.29, 4.08, 1.24, 0],
  'city-detail-parasol-a': [0.35, 0.45, 0.4, 0],
  'city-detail-parasol-b': [0.35, 0.45, 0.4, 0],
  'city-low-detail-building-a': [0.5, 2, 0.5, 0],
  'city-low-detail-building-b': [0.5, 2.23, 0.5, 0],
  'city-low-detail-building-c': [0.5, 2.25, 0.5, 0],
  'city-low-detail-building-d': [0.5, 1.75, 0.5, 0],
  'city-low-detail-building-e': [0.5, 1.8, 0.5, 0],
  'city-low-detail-building-f': [0.5, 2, 0.5, 0],
  'city-low-detail-building-g': [0.5, 2, 0.5, 0],
  'city-low-detail-building-h': [0.5, 2.1, 0.5, 0],
  'city-low-detail-building-i': [0.5, 1.77, 0.5, 0],
  'city-low-detail-building-j': [0.5, 1.75, 0.5, 0],
  'city-low-detail-building-k': [0.5, 1.55, 0.5, 0],
  'city-low-detail-building-l': [0.5, 1.85, 0.5, 0],
  'city-low-detail-building-m': [0.5, 1.98, 0.5, 0],
  'city-low-detail-building-n': [0.5, 0.7, 0.5, 0],
  'city-low-detail-building-wide-a': [1, 1.1, 0.5, 0],
  'city-low-detail-building-wide-b': [1, 1.15, 0.5, 0],
  'suburb-building-type-a': [1.3, 0.83, 1.03, 0],
  'suburb-building-type-b': [1.83, 1.14, 1.14, 0],
  'suburb-building-type-c': [1.29, 1.03, 1.03, 0],
  'suburb-building-type-d': [1.76, 1.24, 1.03, 0],
  'suburb-building-type-e': [1.3, 1.14, 1.03, 0],
  'suburb-building-type-f': [1.43, 1.14, 1.41, 0],
  'suburb-building-type-g': [1.45, 0.77, 1.18, 0],
  'suburb-building-type-h': [1.3, 0.74, 0.92, 0],
  'suburb-building-type-i': [1.29, 0.74, 1.03, 0],
  'suburb-building-type-j': [1.37, 1.04, 0.92, 0],
  'suburb-building-type-k': [0.92, 1.15, 1.02, 0],
  'suburb-building-type-l': [1.03, 1.05, 1.02, 0],
  'suburb-building-type-m': [1.43, 0.74, 1.43, 0],
  'suburb-building-type-n': [1.78, 1.14, 1.38, 0],
  'suburb-building-type-o': [1.27, 1.14, 1.03, 0],
  'suburb-building-type-p': [1.24, 0.92, 0.99, 0],
  'suburb-building-type-q': [1.24, 0.92, 0.89, 0],
  'suburb-building-type-r': [1.03, 1.14, 1.02, 0],
  'suburb-building-type-s': [1.41, 1.14, 1.09, 0],
  'suburb-building-type-t': [1.31, 1.16, 1.41, 0],
  'suburb-building-type-u': [1.43, 1.14, 1.09, 0],
  'suburb-fence-1x2': [0.88, 0.27, 0.44, 0],
  'suburb-fence-low': [1.28, 0.17, 0.84, 0],
  'suburb-planter': [0.4, 0.18, 0.3, 0],
  'suburb-tree-large': [0.21, 0.77, 0.24, 0],
  'suburb-tree-small': [0.21, 0.57, 0.24, 0],
  'urban-detail-barrier-strong-damaged': [0.66, 0.33, 0.25, 0],
  'urban-detail-barrier-strong-type-a': [0.66, 0.33, 0.25, 0],
  'urban-detail-barrier-strong-type-b': [0.66, 0.33, 0.25, 0],
  'urban-detail-barrier-type-a': [0.43, 0.4, 0.13, 0],
  'urban-detail-barrier-type-b': [0.57, 0.3, 0.13, 0],
  'urban-detail-bench': [0.6, 0.41, 0.32, 0],
  'urban-detail-dumpster-closed': [0.6, 0.54, 0.45, 0],
  'urban-detail-dumpster-open': [0.6, 0.55, 0.48, 0],
  'urban-detail-light-double': [0.09, 0.96, 0.44, 0],
  'urban-detail-light-single': [0.09, 0.96, 0.26, 0],
  'urban-detail-light-traffic': [0.16, 1.04, 0.58, 0],
  'urban-pallet-small': [0.5, 0.15, 0.58, 0],
  'urban-pallet': [1, 0.15, 1, 0],
  'urban-scaffolding-structure': [1, 1, 1, 0],
  'urban-tree-large': [1.3, 1.7, 1.3, 0],
  'urban-tree-park-large': [1.04, 1.46, 1.04, 0],
  'urban-tree-park-pine-large': [1.04, 1.46, 1.04, 0],
  'urban-tree-pine-large': [1.3, 1.7, 1.3, 0],
  'urban-tree-pine-small': [0.7, 0.4, 0.7, 0],
  'urban-tree-shrub': [0.78, 0.3, 0.78, 0],
  'urban-tree-small': [0.78, 0.3, 0.78, 0],
  'urban-truck-flat': [0.83, 1.01, 1.64, 0],
  'urban-truck-green-cargo': [0.83, 0.74, 1.17, 0],
  'urban-truck-green': [0.83, 1.01, 1.64, 0],
  'urban-truck-grey-cargo': [0.83, 0.74, 1.17, 0],
  'urban-truck-grey': [0.83, 1.01, 1.64, 0],
  'camp-barrel-open': [0.24, 0.34, 0.24, 0],
  'camp-barrel': [0.24, 0.34, 0.24, 0],
  'camp-bedroll': [0.31, 0.12, 0.61, -0.05],
  'camp-box-large-open': [0.25, 0.31, 0.5, 0],
  'camp-box-large': [0.25, 0.25, 0.5, 0],
  'camp-box-open': [0.25, 0.31, 0.25, 0],
  'camp-box': [0.25, 0.25, 0.25, 0],
  'camp-bucket': [0.14, 0.19, 0.14, 0],
  'camp-campfire-fishing-stand': [0.39, 0.28, 0.25, 0],
  'camp-campfire-pit': [0.28, 0.11, 0.27, 0],
  'camp-campfire-stand': [0.41, 0.28, 0.12, 0],
  'camp-fish-large': [0.31, 0.16, 0.1, 0],
  'camp-fish': [0.2, 0.11, 0.07, 0],
  'camp-resource-planks': [0.37, 0.09, 0.63, 0],
  'camp-resource-stone-large': [0.38, 0.16, 0.34, 0],
  'camp-resource-stone': [0.17, 0.11, 0.14, 0],
  'camp-resource-wood': [0.21, 0.06, 0.09, 0],
  'camp-rock-a': [0.56, 0.39, 0.62, 0],
  'camp-rock-b': [0.83, 0.42, 0.72, 0],
  'camp-rock-c': [0.78, 0.51, 0.57, 0],
  'camp-rock-flat-grass': [1.79, 0.23, 1.45, 0],
  'camp-rock-flat': [1.79, 0.19, 1.45, 0],
  'camp-rock-sand-a': [0.56, 0.39, 0.48, 0],
  'camp-rock-sand-b': [0.8, 0.45, 0.79, 0],
  'camp-rock-sand-c': [0.78, 0.51, 0.57, 0],
  'camp-signpost-single': [0.21, 0.46, 0.04, 0],
  'camp-signpost': [0.21, 0.46, 0.04, 0],
  'camp-tent-canvas-half': [0.56, 0.49, 0.56, 0],
  'camp-tent-canvas': [0.56, 0.49, 0.56, 0],
  'camp-tent': [0.56, 0.49, 0.56, 0],
  'camp-tree-autumn-tall': [0.55, 1.71, 0.53, 0],
  'camp-tree-autumn-trunk': [0.2, 0.26, 0.2, 0],
  'camp-tree-autumn': [0.55, 1.41, 0.53, 0],
  'camp-tree-log-small': [0.25, 0.28, 0.65, 0],
  'camp-tree-log': [0.25, 0.28, 1, -0.11],
  'camp-tree-tall': [0.55, 1.71, 0.53, 0],
  'camp-tree-trunk': [0.2, 0.26, 0.2, 0],
  'camp-tree': [0.55, 1.41, 0.53, 0],
  'camp-workbench-anvil': [0.32, 0.34, 0.3, 0],
  'camp-workbench-grind': [0.26, 0.28, 0.33, 0],
  'camp-workbench': [0.33, 0.29, 0.3, 0],
  'factory-box-large': [1.1, 0.55, 1, 0],
  'factory-box-long': [1.1, 0.55, 0.5, 0],
  'factory-box-small': [0.59, 0.55, 0.5, 0],
  'factory-box-wide': [0.59, 0.55, 1, 0],
  'factory-cog-a': [1, 0.22, 1, -0.15],
  'factory-cog-b': [1, 0.22, 1, -0.15],
  'factory-cog-c': [1, 0.22, 1, -0.15],
  'factory-cog-d': [1, 0.22, 1, -0.15],
  'factory-cog-e': [1, 0.22, 1, -0.15],
  'factory-cone': [0.3, 0.31, 0.3, 0],
  'factory-crane-lift': [0.72, 2.5, 0.72, -2.25],
  'factory-crane-magnet': [0.72, 0.9, 0.72, 0],
  'factory-crane': [1.93, 3.55, 3.68, 0],
  'factory-hopper-high-round': [1.12, 1.5, 1.12, 0],
  'factory-hopper-high-square': [1.12, 1.5, 1.12, 0],
  'factory-hopper-round': [1.12, 1, 1.12, 0],
  'factory-hopper-square': [1.12, 1, 1.12, 0],
  'factory-machine-fortified': [1.2, 1.35, 1.6, 0],
  'factory-machine-window-bar': [1.2, 1.29, 1.5, 0],
  'factory-machine-window': [1.2, 1.29, 1.5, 0],
  'factory-machine': [1.2, 1.3, 1.5, 0],
  'factory-pipe-glass-large': [1, 1, 1, 0],
  'factory-pipe-large': [1, 1, 1, 0],
  'factory-piston-round': [1, 1, 1, 0],
  'factory-piston-square': [1, 1, 1, 0],
  'factory-robot-arm-a': [1, 3.2, 1, 0],
  'factory-robot-arm-b': [1, 3, 1, 0],
  'factory-scanner-high': [0.48, 1.27, 1.77, 0],
  'factory-scanner-low': [0.7, 1.07, 1.6, 0],
  'factory-screen-flat': [1.2, 0.75, 0.64, 0],
  'factory-screen-small': [0.6, 0.99, 0.5, 0],
  'factory-screen-wide': [1.2, 0.99, 0.49, 0],
  'crystal-detail-crystal-large': [0.89, 0.55, 0.86, 0],
  'crystal-detail-crystal': [0.25, 0.42, 0.29, 0],
  'crystal-detail-rocks-large': [0.89, 0.41, 0.86, 0],
  'crystal-detail-rocks': [0.6, 0.18, 0.61, 0],
  'crystal-detail-tree-large': [0.5, 0.76, 0.5, 0],
  'crystal-detail-tree': [0.35, 0.53, 0.35, 0],
  'crystal-enemy-ufo-a': [1, 0.68, 1, 0],
  'crystal-enemy-ufo-b': [1, 0.58, 1, 0],
  'crystal-enemy-ufo-c': [1, 0.53, 1, 0],
  'crystal-enemy-ufo-d': [0.95, 0.54, 0.95, 0],
  'crystal-snow-detail-crystal-large': [0.89, 0.55, 0.86, 0],
  'crystal-snow-detail-crystal': [0.25, 0.42, 0.29, 0],
  'crystal-snow-detail-rocks-large': [0.89, 0.41, 0.86, 0],
  'crystal-snow-detail-rocks': [0.6, 0.18, 0.61, 0],
  'crystal-snow-detail-tree-large': [0.5, 0.76, 0.5, 0],
  'crystal-snow-detail-tree': [0.35, 0.53, 0.35, 0],
  'crystal-tower-round-crystals': [1, 0.82, 1, 0],
  'castle-bridge-straight-pillar': [0.93, 1.18, 0.93, 0],
  'castle-bridge-straight': [0.93, 1.18, 0.93, 0],
  'castle-flag-banner-long': [0.04, 2.17, 0.63, 0],
  'castle-flag-banner-short': [0.04, 0.78, 0.63, 0],
  'castle-flag-pennant': [0.11, 0.87, 0.57, 0],
  'castle-flag-wide': [0.11, 0.87, 0.55, 0],
  'castle-flag': [0.11, 0.87, 0.43, 0],
  'castle-rocks-large': [1.2, 0.5, 1.35, 0],
  'castle-rocks-small': [1.03, 0.5, 1.11, 0],
  'castle-siege-ballista-demolished': [1.75, 0.51, 1.55, 0],
  'castle-siege-ballista': [1.63, 0.91, 1.2, 0],
  'castle-siege-catapult-demolished': [1.68, 0.32, 1.67, 0],
  'castle-siege-catapult': [1.73, 1.33, 1.21, -0.15],
  'castle-siege-ram-demolished': [2.08, 0.72, 1.65, 0],
  'castle-siege-ram': [2.09, 1.18, 1, 0],
  'castle-siege-tower-demolished': [2.17, 2.1, 1.85, 0],
  'castle-siege-tower': [1.97, 2.68, 1.21, 0],
  'castle-siege-trebuchet-demolished': [1.93, 0.31, 2.1, 0],
  'castle-siege-trebuchet': [1.85, 1.96, 1.26, 0],
  'castle-tower-hexagon-base': [0.9, 1.31, 0.78, 0],
  'castle-tower-square': [1, 1.31, 1, 0],
  'castle-tree-large': [0.89, 1.85, 0.89, 0],
  'castle-tree-log': [0.25, 0.28, 1, -0.11],
  'castle-tree-small': [0.74, 1.35, 0.72, 0],
  'castle-tree-trunk': [0.4, 0.38, 0.34, 0],
  'pirate-barrel': [1.34, 1.23, 1.34, 0],
  'pirate-boat-row-large': [2.75, 0.85, 2.85, 0],
  'pirate-boat-row-small': [2.75, 0.85, 2.37, 0],
  'pirate-bottle-large': [0.47, 0.89, 0.47, 0],
  'pirate-bottle': [0.36, 0.89, 0.36, 0],
  'pirate-cannon-ball': [0.64, 0.67, 0.55, -0.34],
  'pirate-cannon-mobile': [1.68, 1.38, 1.92, 0],
  'pirate-cannon': [1.4, 1.05, 1.92, 0],
  'pirate-chest': [1.27, 1.15, 1.27, 0],
  'pirate-crate-bottles': [1.08, 1.06, 1.31, 0],
  'pirate-crate': [1.08, 0.77, 1.31, 0],
  'pirate-flag-pirate-high-pennant': [1.76, 3.6, 0.4, 0],
  'pirate-flag-pirate-high': [1.34, 3.6, 0.4, 0],
  'pirate-flag-pirate-pennant': [1.76, 2.1, 0.4, 0],
  'pirate-flag-pirate': [1.34, 2.1, 0.4, 0],
  'pirate-grass-plant': [1.11, 0.52, 1.24, 0],
  'pirate-palm-bend': [2.88, 4.25, 3.22, 0],
  'pirate-palm-detailed-bend': [2.88, 4.25, 3.22, 0],
  'pirate-palm-detailed-straight': [3.22, 4.21, 3.22, 0],
  'pirate-palm-straight': [2.49, 4.21, 2.49, 0],
  'pirate-rocks-a': [5.11, 2.9, 4.39, 0],
  'pirate-rocks-b': [4.44, 3.65, 4.7, 0],
  'pirate-rocks-c': [3.64, 2.3, 3.67, 0],
  'pirate-rocks-sand-a': [5.11, 3.21, 4.39, 0],
  'pirate-rocks-sand-b': [4.38, 3.71, 4.71, 0],
  'pirate-rocks-sand-c': [3.71, 2.61, 3.72, 0],
  'pirate-ship-ghost': [4.8, 9.96, 10.6, 0],
  'pirate-ship-large': [4.8, 9.96, 13.1, 0],
  'pirate-ship-medium': [4.8, 9.96, 10.6, 0],
  'pirate-ship-pirate-large': [4.8, 9.96, 13.1, 0],
  'pirate-ship-pirate-medium': [4.8, 9.96, 10.6, 0],
  'pirate-ship-pirate-small': [4.8, 9.96, 8.8, 0],
  'pirate-ship-small': [4.8, 9.96, 8.8, 0],
  'pirate-ship-wreck': [4.8, 9.96, 10.6, 0],
  'pirate-tower-complete-large': [3.63, 10.22, 3.63, 0],
  'pirate-tower-complete-small': [3.35, 6.78, 3.66, 0],
  'pirate-tower-watch': [3.05, 2.79, 3.05, 0],
  'arena-banner': [0.6, 1.02, 0.23, 0],
  'arena-column-damaged': [0.6, 0.72, 0.6, 0],
  'arena-column': [0.6, 1, 0.6, 0],
  'arena-statue': [0.7, 1.34, 0.7, 0],
  'arena-tree': [0.65, 1.92, 0.65, 0],
  'arena-trophy': [0.57, 0.48, 0.45, 0],
  'arena-weapon-rack': [0.72, 0.47, 0.3, 0],
  'ruins-plants3': [0.17, 0.21, 0.05, 0],
  'ruins-plants1': [0.16, 0.12, 0.03, 0],
  'ruins-plants4': [0.23, 0.23, 0.06, 0],
  'ruins-plants5': [0.15, 0.35, 0.09, 0],
  'ruins-plants6': [0.2, 0.34, 0.1, 0],
  'ruins-plants2': [0.21, 0.15, 0.04, 0],
  'ruins-plants7': [0.16, 0.36, 0.1, 0],
  'ruins-plants8': [0.22, 0.15, 0.26, 0],
  'ruins-plants9': [0.29, 0.15, 0.26, 0],
  'ruins-plants10': [0.25, 0.21, 0.31, 0],
  'ruins-plants11': [0.32, 0.23, 0.33, 0],
  'ruins-plants12': [0.34, 0.23, 0.34, 0],
  'ruins-plants13': [0.17, 0.35, 0.21, 0],
  'ruins-plants14': [0.33, 0.35, 0.22, 0],
  'ruins-plants15': [0.36, 0.35, 0.38, 0],
  'ruins-plants16': [0.44, 0.35, 0.4, 0],
  'ruins-plants17': [0.23, 0.36, 0.26, 0],
  'ruins-plants18': [0.27, 0.36, 0.32, 0],
  'ruins-plants19': [0.38, 0.36, 0.34, 0],
  'ruins-plants20': [0.41, 0.36, 0.44, 0],
  'ruins-sword': [0.53, 1.96, 0.27, 0],
  'ruins-shell': [1.95, 1, 0.76, 0],
  'ruins-rock2': [0.33, 0.26, 0.31, 0],
  'ruins-rock4': [0.34, 0.83, 0.32, 0],
  'ruins-rock3': [0.44, 0.53, 0.41, 0],
  'ruins-rock1': [0.21, 0.19, 0.18, 0],
  'forest-oak-tree-trunk': [1.4, 1.78, 1.45, 0],
  'forest-fly-agaric': [0.15, 0.17, 0.16, 0],
  'forest-fern': [0.63, 0.27, 0.64, 0],
  'forest-fern-2': [0.71, 0.3, 0.68, 0],
  'forest-fern-3': [0.78, 0.26, 0.7, 0],
  'forest-ceps': [0.15, 0.16, 0.16, 0],
  'forest-ceps-2': [0.15, 0.18, 0.16, 0],
  'forest-fly-agaric-2': [0.14, 0.17, 0.15, 0],
  'forest-oak-tree-trunk-2': [2.09, 1.99, 2.17, 0],
  'forest-oak-tree-trunk-3': [1.4, 1.58, 1.45, 0],
  'forest-oak-tree-trunk-4': [2.25, 1.5, 2.05, 0],
  'forest-oak-tree-trunk-5': [2.34, 1.7, 2.04, 0],
  'forest-oak-tree-trunk-6': [1.71, 1.39, 2.27, 0],
  'forest-pine-tree-trunk': [2.16, 1.63, 2.38, 0],
  'forest-pine-tree-trunk-2': [1.84, 1.9, 2.17, 0],
  'forest-pine-tree-trunk-3': [1.65, 1.39, 2.27, 0],
  'forest-tree-trunk': [2.08, 1.84, 1.98, 0],
  'forest-tree-trunk-2': [1.52, 2.02, 1.45, 0],
  'forest-tree-trunk-3': [1.4, 1.36, 1.34, 0],
  'forest-birch-tree-trunk': [1.64, 2, 1.55, 0],
  'forest-birch-tree-trunk-2': [1.87, 2.35, 1.69, 0],
  'forest-birch-tree-trunk-3': [1.92, 1.91, 1.44, 0],
  'forest-honey-mushroom': [0.16, 0.16, 0.21, 0],
  'forest-chanterelle': [0.17, 0.12, 0.16, 0],
  'forest-pine-log': [0.9, 0.24, 0.26, 0],
  'forest-pine-log-2': [0.88, 0.22, 0.25, 0],
  'forest-pine-stump': [0.78, 0.51, 0.93, 0],
  'forest-pine-stump-2': [0.83, 0.55, 0.82, 0],
  'forest-birch-stump': [0.4, 0.55, 0.37, 0],
  'forest-oak-stump': [0.81, 0.43, 0.85, 0],
  'forest-oak-stump-2': [0.95, 0.43, 1.12, 0],
  'forest-stone': [0.48, 0.22, 0.47, 0],
  'forest-stone-2': [0.62, 0.33, 0.37, 0],
  'forest-stone-3': [0.63, 0.22, 0.7, 0],
  'forest-mossed-stone': [0.49, 0.22, 0.47, 0],
  'forest-stone-4': [0.47, 0.26, 0.5, 0],
  'forest-mossed-stone-2': [0.7, 0.22, 0.68, 0],
  'forest-birch-log': [0.9, 0.24, 0.26, 0],
  'forest-log': [0.88, 0.22, 0.25, 0],
  'forest-light-bush': [0.64, 0.79, 0.64, 0],
  'forest-light-bush-2': [1.19, 0.87, 0.96, 0],
  'forest-light-bush-3': [1.25, 0.74, 0.69, 0],
  'forest-light-bush-4': [0.67, 0.81, 0.67, 0],
  'forest-grassblade': [0.58, 0.58, 0.58, 0],
  'forest-grassblade-2': [0.58, 0.58, 0.58, 0],
  'forest-mossed-stone-3': [0.63, 0.34, 0.7, 0],
  'forest-mossed-stone-4': [0.62, 0.3, 0.66, 0],
  'forest-mossed-stone-5': [0.73, 0.44, 0.61, 0],
  'forest-mossed-stone-6': [0.76, 0.37, 0.73, 0],
  'forest-dandelion-flowers': [0.96, 0.15, 0.91, 0],
  'forest-dark-bush': [0.64, 0.79, 0.64, 0],
  'forest-dark-bush-2': [1.19, 0.87, 0.96, 0],
  'forest-dark-bush-3': [1.25, 0.74, 0.69, 0],
  'forest-dark-bush-4': [0.67, 0.81, 0.67, 0],
  'ivy-small-ivy': [1.77, 0.9, 0.22, 0],
  'ivy-small-ivy-2': [0.71, 1.79, 0.19, 0],
  'ivy-small-ivy-3': [0.9, 2.07, 0.22, 0],
  'ivy-ivy-2-lod-0': [2.42, 1.19, 0.35, 0],
  'ivy-ivy-1-lod-0': [2.52, 1.65, 0.35, 0],
  'reeds-reed-1': [0.03, 0.82, 0.03, 0],
  'reeds-reed-1-2': [0.4, 0.79, 0.37, 0],
  'reeds-reed-2': [0.07, 0.81, 0.02, 0],
  'reeds-reed-2-2': [0.5, 0.77, 0.41, 0],
  'reeds-reed-3': [0.05, 0.82, 0.03, 0],
  'reeds-reed-3-2': [0.47, 0.77, 0.47, 0],
  'reeds-reed-4': [0.07, 0.81, 0.03, 0],
  'reeds-reed-4-2': [0.45, 0.78, 0.49, 0],
  'reeds-reed-5': [0.09, 0.81, 0.04, 0],
  'reeds-reed-5-2': [0.5, 0.8, 0.45, 0],
};
